import Alert from '@customink/pigment-react/lib/components/Alert';

type TaxExemptProps = {
  taxState?: string;
};

export default function TaxExemptNotApproved({ taxState }: TaxExemptProps) {
  return (
    <Alert data-testid="tax-exempt-not-approved" severity="info">
      You are not approved for tax exempt purchases in {taxState}.
    </Alert>
  );
}
